import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LessonPageItem } from '../../../data/models/LessonPageItem';

import { LessonPageItemTypeEnum } from '../../../data/enums/LessonPageItemType';
import { QuizAnswerTileComponent } from "../quiz-answer-tile/quiz-answer-tile.component";

@Component({
    selector: 'app-lesson-page',
    imports: [QuizAnswerTileComponent],
    templateUrl: './lesson-page.component.html',
    styleUrl: './lesson-page.component.scss'
})
export class LessonPageComponent {
  @Input() items: LessonPageItem[] = []
  LessonPageItemTypeEnum = LessonPageItemTypeEnum;
  selectedAnswers: string[] = [];
  @Output() answerSelectionChange = new EventEmitter<string[]>();
  @Output() pressQuizButton = new EventEmitter<void>();
  @Output() onVideoStartedEvent = new EventEmitter<LessonPageItem>();

  toggleAnswerSelection(id: string): void {
    const selectedIndex = this.selectedAnswers.indexOf(id);
    if (selectedIndex === -1) {
      this.selectedAnswers.push(id); 
    } else {
      this.selectedAnswers.splice(selectedIndex, 1);
    }
    this.answerSelectionChange.emit(this.selectedAnswers);
  }

  get videoItems() {
    return this.items?.filter(i => i.type.title === LessonPageItemTypeEnum.VIDEO);
  }

  pressAnswerButton(): void {
    this.pressQuizButton.emit();
  }

  clearSelection() {
    this.selectedAnswers = []
  }

  onVideoStarted(item: LessonPageItem){
    this.onVideoStartedEvent.emit(item);
  }
}
